<template>
  <div class="position-relative">
    <div>
        <template v-if="collaborateSuppliers.length > 0">
            <CollaborateWithSuppliers :suppliers="collaborateSuppliers" />
        </template>
      
        <!-- :typeOfTableFilter="typeOfTableFilter" -->
        <tsoft-table
            :name="typeOfTableFilter"
            :key="componentRefreshKey"
            :api="tableApiUrl"
            :items.sync="items"
            :isNeedSearch="false"
            :additionalGetParameter="additionalGetParameter"
      
            :typeOfTableFilter="''"
            :onDataEmptyMessage="'Запросы к поставщикам отсутствуют.'"
            :headerContextMenuName="'orderWorkWithSuppliersTable'"
            customAddButtonName="Создать запрос поставщику"
            @show="showItem"
            @edit="createOrEditItemModal"
            @delete="deleteItem"
        />
    </div>

    <div 
        v-if="isSidebarOpen"
        class="position-absolute abs-sidebar-block"
    >
        <div class="d-flex justify-content-space-between align-items-center mb-4">
            <h5 id="sidebar-right___title__" class="m-0" v-html="modalTitle()"></h5>
            <div v-if="smtpAvailable && formStep == 1">
                Составить из формы котировки
                <b-button 
                    @click="generateFromDeliveryQuotation('rus')"
                    :disabled="generatingFromDQ"
                    variant="outline-secondary"
                    class="btn btn-sm small ml-1"
                >Рус</b-button>
                <b-button 
                    @click="generateFromDeliveryQuotation('eng')"
                    :disabled="generatingFromDQ"
                    variant="outline-secondary"
                    class="btn btn-sm small ml-1"
                >Eng</b-button>
                <b-button 
                    @click="isSidebarOpen = false"
                    :disabled="generatingFromDQ"
                    variant="outline-secondary"
                    class="btn btn-sm small ml-1"
                >X</b-button>
            </div>
        </div>
      <div class="d-block">
        <template v-if="!smtpChecked">
          <p>Проверка настроек почты...</p>
        </template>
        <template v-else-if="smtpAvailable">            
          <form class="needs-validation mb-4" novalidate id="OrderSupplierRequestForm">
            <template v-if="formStep == 1">
              <div class="form-row">
                <div class="form-group col-md-12">
                  <div class="form-row">
                    <div class="form-group col-md-12">
                      <label>Тема письма</label>
                      <b-form-input
                        required
                        id="subject"
                        type="text"
                        :disabled="generatingFromDQ"
                        v-model="editedItem.subject"
                      ></b-form-input>
                    </div>
                    <div class="form-group col-md-12">
                      <label>Содержимое письма</label>
                      <VueEditor
                        class="comment-editor"
                        ref="bodyEditor"
                        id="body-editor"
                        required
                        :disabled="generatingFromDQ"
                        v-model="editedItem.body"
                        :editorToolbar="customToolbar"
                        resize="both"
                      />                          
                    </div>
                  </div>
                </div>
              </div>
              
              <div class="form-row">
                <div class="form-group col-md-7">
                  <label>Вложения</label>
                  <input type="file" multiple @change="handleFileUpload" class="form-control" />
                </div>
                <div class="form-group col-md-5">
                  <template v-if="editedItem.attachments.length > 0">
                    <label>Добавленные ранее вложения</label>
                    <b-list-group>
                      <b-list-group-item>
                        Приложения: 
                        <template v-for="(item, index) in editedItem.attachments">
                          <a :href="`${hfs}uploads/${item}`" target="_blank">Файл {{ index + 1 }}</a>
                          <template v-if="editedItem.attachments[index + 1]">
                            | 
                          </template>
                        </template>
                      </b-list-group-item>
                    </b-list-group>                                
                  </template>
                </div>
              </div>
            </template>
            <template v-if="formStep == 2">
              <div class="form-row">
                <div class="form-group col-md-12">
                  <FilterByTransportCompanies
                    :popupView="false"
                    :searchParameters="searchedSuppliers.searchData"
                    @startSearch="startSearch"
                    @disableSearch="disableSearch"
                  ></FilterByTransportCompanies>
                </div>
              </div>

              <div class="row">
                <div class="col-sm-12 position-relative">
                  <h5 class="mb-0">Найденные поставщики</h5>
                  <div class="mb-3">
                    <small v-if="searchedSuppliers.allSearchedSuppliers.data && 
                                searchedSuppliers.allSearchedSuppliers.data.length > 0"
                    ><em>Нажимайте на строки с компаниями, которые вы хотите опросить письмом. Если подходят все, нажмите на галочку над первой колонкой.</em></small>
                  </div>
                  <div class="fly-count" v-if="searchedSuppliers.allSearchedSuppliers && searchedSuppliers.allSearchedSuppliers.total">
                    <small>Записей найдено: {{ searchedSuppliers.allSearchedSuppliers.total }}</small>
                  </div>
                </div>
              </div>

              <div class="form-row">
                <div class="form-group col-md-12">
                  <div v-if="searchedSuppliers.allSearchedSuppliers.data && 
                            searchedSuppliers.allSearchedSuppliers.data.length > 0">
                    <CompanyListForMailing
                      :items="searchedSuppliers.allSearchedSuppliers"
                      :selectedItems.sync="searchedSuppliers.selectedSuppliers"
                      @updateSelectedItems="updateSelectedItems"
                    ></CompanyListForMailing>
                  </div>
                  <div v-else>
                      <div v-if="searchedSuppliers.allSearchedSuppliers.data">
                        <p><em>Не найдено ни одного совпадения по указанным условиям. Попробуйте изменить условия.</em></p>
                      </div>
                      <div v-else>
                        <p><em>Нажмите «Поиск компаний», чтобы поискать подходязие варианты для отправки предложений.</em></p>
                      </div>
                  </div>
                </div>
              </div>

              <div 
                class="form-row"
                v-if="searchedSuppliers.allSearchedSuppliers.data && 
                      searchedSuppliers.allSearchedSuppliers.data.length > 0"
              >
                <div class="form-group col-md-12"><h5 class="mb-0">Вы отобрали</h5></div>
                <div class="form-group col-md-12">
                  <b-list-group>
                    <b-list-group-item><b>Компаний: </b>{{ searchedSuppliers.selectedSuppliers.length }}</b-list-group-item>
                    <b-list-group-item><b>Контактов для рассылки: </b>{{ searchedSuppliers.selectedSuppliersEmployee.length }}</b-list-group-item>
                  </b-list-group>                    
                </div>
              </div>
            </template>

            <hr>

            <div class="form-row mt-4">
              <div class="col-md-12 text-right">
                <b-button
                  v-if="formStep == 2"
                  variant="secondary"
                  @click.prevent="formStep = 1"
                  class="mr-2"
                >Вернуться к письму</b-button>

                <template v-if="formStep == 1">
                  <p 
                    v-if="editedItem.subject == '' || editedItem.text == ''"
                    style="font-size: 11px; line-height: 12px;"
                  ><em>Перейти далее можно, если заполнены поля <br>«Тема» и «Содержимое письма».</em></p>
                  <b-button
                    :variant="(editedItem.subject == '' || editedItem.text == '') ? 'secondary':'primary'" 
                    @click.prevent="formStep = 2"
                    :disabled="editedItem.subject == '' || editedItem.text == ''"
                  >Перейти к отбору поставщиков</b-button>
                </template>

                <b-button
                  v-if="formStep == 2"
                  variant="primary"
                  type="submit"
                  @click="submitForm($event)"
                >Сохранить и продолжить</b-button>
              </div>
            </div>
          </form>
        </template>
        <template v-else>
          <b-jumbotron header-level="5" header="Не настроена связка с почтой">
            <p class="lead">Перейдите в настройки вашего профиля и внесите настройки для рассылок.</p>
            <b-button variant="primary" href="/profile">Перейти к настройке &raquo;</b-button>
          </b-jumbotron>
        </template>    
      </div>
    </div>
    <!-- <b-sidebar
      v-if="isSidebarOpen"
      v-model="isSidebarOpen"
      id="sidebar-right"
      right
      backdrop
      shadow
      width="109em"
      backdrop-variant="dark"
      ref="editItem"
      no-close-on-backdrop
      @change="closeSidePanelCallback()"
    >
      <template #title>
        <div>
          <strong id="sidebar-right___title__" v-html="modalTitle()"></strong>
        </div>
      </template>
    </b-sidebar> -->

    <b-sidebar
        v-if="isShowSidebar"
        v-model="isShowSidebar"
        id="sidebar-right-work-with-supplier"
        right
        backdrop
        shadow
        :width="['sm','md'].includes($mq) ? '109em':'95%'"
        backdrop-variant="dark"
        no-close-on-backdrop
        @change="closeShowSidePanelCallback"
    >
        <template #title>
            <div>
                <strong id="sidebar-right___title__">Запрос поставщику #{{ editedItem.id }}</strong>
            </div>
        </template>

        <CompanySupplierRequestShowOne
          :editedItem="editedItem"
          :isItemRefreshing="isItemRefreshing"
          @updateShowItemData="updateShowItemData"
        ></CompanySupplierRequestShowOne>
    </b-sidebar>        
  </div>
</template>

<script>
  import { API_ORDER_SUPPLIER, API_COMPANY, API_CHECK_SMTP_AVAILABILITY, HOST_FOR_STORAGE, API_POST_ORDER_SERVICES_QUOTATIONS_FIND } from "@/constants";
  import { 
    defaultDataItems, 
    actionShowItem, 
    actionCreateOrUpdateItem, 
    actionDeleteItem,
    dataHelpers
  } from "@/mixins";
  import FilterByTransportCompanies from "@/components/companies/CompanyTableFilterByTransportCompanies";
  import CompanyListForMailing from "@/components/companies/CompanyListForMailing";
  import CompanySupplierRequestShowOne from "@/components/companies/CompanySupplierRequestShowOne";
  import { VueEditor } from "vue2-editor";
  import { renderComponentToString } from '@/services/renderComponentToString';
  import DeliveryQuotationLetter from '@/components/orders/orderServiceQuotation/DeliveryQuotationLetter';
  import DeliveryQuotationLetterEng from '@/components/orders/orderServiceQuotation/DeliveryQuotationLetterEng';
  import CollaborateWithSuppliers from "@/components/orders/orderServiceQuotation/CollaborateWithSuppliers.vue";

  const initialEditedItem = () => ({
    id: '',
    order_id: '',
    creator_user_id: '',
    subject: '',
    body: '',
    search_parameters: '',
    attachments: [],
    attachments_count: 0,
    emails_count: 0,
    sent_emails_count: 0,
    sent_errors_count: 0,
    retrying_emails_count: 0,
    responded_emails_count: 0,
    order: {},
    creator: {},
    emails: [],
    sent_emails: [],
    sent_errors: [],
    responded_emails: []
  });

  const initialSearchedSuppliers = () => ({
    searchData: {},
    allSearchedSuppliers: [],
    selectedSuppliers: [],
    selectedSuppliersEmployee: []
  });
  
  export default {
    mixins: [
      defaultDataItems, 
      actionShowItem, 
      actionCreateOrUpdateItem, 
      actionDeleteItem,
      dataHelpers
    ],
    props: {
      orderId: { type: [Number, String], required: false },
      isNeedCreate: { type: Boolean, required: false, default: true },
      additionalGetParameter: { type: String, required: false, default: '' },
      typeOfTableFilter: { type: String, required: false, default: 'order-suppliers-request' }
    },
    components: {
      FilterByTransportCompanies,
      CompanyListForMailing,
      CompanySupplierRequestShowOne,
      VueEditor,
      CollaborateWithSuppliers
    },    
    data() {
      return {
        changeLoad: false,
        generatingFromDQ: false,
        tableApiUrl: API_ORDER_SUPPLIER,
        hfs: HOST_FOR_STORAGE,
        componentRefreshKey: 0,
        formStep: 1,
        attachments: [],
        isShowSidebar: false,
        searchedSuppliers: {},
        loadingCompanies: false,
        smtpAvailable: false, // To track SMTP availability
        smtpChecked: false, // To ensure the check is complete
        isItemRefreshing: false,
        customToolbar: [
          // [{ header: [false, 1, 2, 3, 4, 5, 6] }],
          ["bold", "italic", "underline", "strike"], 
          [
            { align: "" },
            { align: "center" },
            { align: "right" },
            { align: "justify" }
          ],
          ["blockquote"],
          [{ list: "ordered" }, { list: "bullet" }],
          [{ indent: "-1" }, { indent: "+1" }], 
          [{ script: "sub" }, { script: "super" }],
          [{ color: [] }, { background: [] }],
          ["link"],
          ["clean"]
        ],
      };
    },
    watch: {
      'editedItem.body': function(newValue) {
        if (newValue) {
          this.editedItem.body = newValue.replace(/<p><br><\/p>/g, '<br>');
        }
      }
    },
    computed: {
      collaborateSuppliers() {
        // Compute the suppliers that can collaborate from your items data
        return this.items.data.flatMap(item => item.can_collaborate || []);
      }
    },    
    mounted() {
      this.editedItem = initialEditedItem();
      this.searchedSuppliers = initialSearchedSuppliers();
      this.initialAssign();
    },
    beforeDestroy() {
      if (this.$route.query['tab-order'] && this.$route.query['tab-order'] == 'order-suppliers') {
        const query = Object.assign({}, this.$route.query);
        delete query['tab-order'];
        this.$router.replace({ query });      
      }
    },
    methods: {
      initialAssign() {
        if (!this.$route.query['tab-order']) {
          this.$router.push({
            query: {
              ...this.$route.query,
              'tab-order': 'order-suppliers'
            }
          });
        }

        if (this.orderId) {
          this.editedItem.order_id = this.orderId;
        }
      },
      showItem(index) {
        this.isShowSidebar = true;
        this.editIndex = index
        this.editedItem = { ...this.items.data[index] }
      },
      showVisibleItemById(id) {
        const index = this.items.data.findIndex(item => item.id === id);

        if (index !== -1) {
          this.showItem(index);
        } else {
          console.log('Элемент не найден в списке.');
        }
      },
      closeShowSidePanelCallback() {
        this.isShowSidebar = false;
        this.editedItem = initialEditedItem();
        this.searchedSuppliers = initialSearchedSuppliers();
        this.initialAssign();
        this.editIndex = -1;
      },
      beforeSidebarOpenedCallback() {
        this.checkSmtpAvailability();
        this.editedItem = initialEditedItem();
        this.searchedSuppliers = initialSearchedSuppliers();
        this.initialAssign();
        this.formStep = 1;
      },
      checkSmtpAvailability() {
        api.call('get', API_CHECK_SMTP_AVAILABILITY)
          .then(response => {
            this.smtpAvailable = response.data === 1;
            this.smtpChecked = true;
          })
          .catch(error => {
            console.error('Error checking SMTP availability:', error);
            this.smtpAvailable = false;
            this.smtpChecked = true;
          });
      },
      onCreatedOrUpdatedCallback() {
        this.isSidebarOpen = false;
        this.editedItem = initialEditedItem();
        this.searchedSuppliers = initialSearchedSuppliers();
        this.editIndex = -1;
        this.formStep = 1;
      },
      onItemEditModalCallback() {
        if (this.editedItem.search_parameters) {
          if (this.editedItem.search_parameters.searchData) {
            this.searchedSuppliers.searchData = JSON.parse(JSON.stringify(this.editedItem.search_parameters.searchData));
          }
          if (this.editedItem.search_parameters.selectedSuppliers) {
            this.searchedSuppliers.selectedSuppliers = JSON.parse(JSON.stringify(this.editedItem.search_parameters.selectedSuppliers));

            if (this.searchedSuppliers.selectedSuppliers.length > 0) {
              this.getItemsByCompanyIds(this.searchedSuppliers.selectedSuppliers);
            }
          }
          if (this.editedItem.search_parameters.selectedSuppliersEmployee) {
            this.searchedSuppliers.selectedSuppliersEmployee = JSON.parse(JSON.stringify(this.editedItem.search_parameters.selectedSuppliersEmployee));
          }
        }
      },
      submitForm(event) {
        event.preventDefault();

        let form = document.getElementById("OrderSupplierRequestForm");
        if (form.checkValidity() === false) {
          event.preventDefault();
          event.stopPropagation();
          form.classList.add('was-validated');
          return false;
        }

        this.createOrUpdateItem();
      },
      onDeletedCallback() {
        this.componentRefreshKey++;
      },
      modalTitle() {
        let title = 'Добавление запроса поставщику';
        if (this.editIndex > -1) {
          title = 'Редактирование запроса поставщику #' + this.editedItem.id;
        }
        return title;
      },
      setCreatedItem(data) {
        this.items.data.unshift(data)
        this.onCreatedOrUpdatedCallback();
      },
      setUpdatedItem(data) {
        Object.assign(this.items.data[this.editIndex], data)
        this.onCreatedOrUpdatedCallback();
      },
      handleFileUpload(event) {
        this.attachments = Array.from(event.target.files);
      },
      createOrUpdateItem() {
        this.savingProcess = true
        if (typeof this.onCreateOrUpdateItemCallback === 'function') {
            this.onCreateOrUpdateItemCallback();
        }

        this.editedItem.search_parameters = {
          searchData: this.searchedSuppliers.searchData,
          selectedSuppliers: this.searchedSuppliers.selectedSuppliers,
          selectedSuppliersEmployee: this.searchedSuppliers.selectedSuppliersEmployee,
        }

        const formData = new FormData();
        formData.append('subject', this.editedItem.subject);
        formData.append('body', this.editedItem.body);
        formData.append('search_parameters', JSON.stringify(this.editedItem.search_parameters));

        this.attachments.forEach((file, index) => {
          formData.append(`attachments[${index}]`, file);
        });

        if (this.editIndex == -1) {
          formData.append('order_id', this.editedItem.order_id);
          api.call("post", this.tableApiUrl, formData, {
            headers: {
                "Content-Type": "multipart/form-data"
            }
          }).then(({data}) => {
            this.savingProcess = false;
            this.setCreatedItem(data);
            this.makeToast('success', 'Запрос поставщику успешно добавлен!');
            this.showVisibleItemById(data.id);
          }).catch((response) => {
            console.error(response);
          })
        } else {
            formData.append('_method', 'PUT');
            api.call("post", `${this.tableApiUrl}/${this.editedItem.id}`, formData, {
              headers: {
                  "Content-Type": "multipart/form-data"
              }
            }).then(({data}) => {
              this.savingProcess = false;
              this.setUpdatedItem(data);
              this.makeToast('info', 'Изменения сохранены');
              this.showVisibleItemById(data.id);
            }).catch((response) => {
              console.error(response);
            })
        }
      },
      startSearch(searchData) {
        this.searchedSuppliers.searchData = searchData;
        this.searchedSuppliers.allSearchedSuppliers = [];
        this.loadingCompanies = true;

        let additionalParameter = 'page=1&per_page=10000&is_transport_company=1&headerName=tableHeadersSupplier';
        let additionalGetParameter = '&' + this.objectToQueryString(searchData)

        api.call('get', API_COMPANY + `?${additionalParameter}${additionalGetParameter}`)
          .then((response) => {
            this.loadingCompanies = false
            this.searchedSuppliers.allSearchedSuppliers = response.data;
          })
      },
      disableSearch(value) {
        console.log('disableSearch', value);
      },
      getItemsByCompanyIds(ids) {
        this.loadingCompanies = true;

        let additionalParameter = 'page=1&per_page=10000&headerName=tableHeadersSupplier';
        let additionalGetParameter = '&' + this.objectToQueryString({by_ids: ids})

        api.call('get', API_COMPANY + `?${additionalParameter}${additionalGetParameter}`)
          .then((response) => {
            this.loadingCompanies = false
            this.searchedSuppliers.allSearchedSuppliers = response.data;
          })
      },
      updateSelectedItems(params) {
        let selectedItems = params.selectedItems;
        let items = params.items;

        this.searchedSuppliers.selectedSuppliers = selectedItems;
        this.searchedSuppliers.selectedSuppliersEmployee = [];

        let allEmployees = this.getAllEmployeesByCompanyIds(selectedItems, items.data);

        if (items.request &&
          items.request.need_employees_with_segments &&
          items.request.need_employees_with_segments == "true" &&
          items.request.set_services_ids &&
          items.request.set_services_ids != ''
        ) {
          // Берем только подходящих по сегменту для оповещения
          let set_services_ids = items.request.set_services_ids.split(',');

          allEmployees = allEmployees.map((item) => {
            if (set_services_ids.some(id => item.set_segments_ids.includes(parseInt(id)))) {
                return item;
            }
          }).filter(item => item !== undefined);
        }

        // Вот тут можно вытащить список имен и телефонов и емейлов если нужно
        this.searchedSuppliers.selectedSuppliersEmployee = allEmployees.map((item) => {
          return item.id;
        });
      },
      getAllEmployeesByCompanyIds(selectedSuppliers, items) {
        let selected = [];

        items.forEach((item) => {
          if (selectedSuppliers.includes(item.id) && item.company_employees && item.company_employees.length > 0) {
            item.company_employees.forEach((employee) => {
              selected.push(employee);
            })
          }
        });

        return selected;
      },
      updateShowItemData(silent = false) {
        this.isItemRefreshing = !silent;

        api.call('get', `${this.tableApiUrl}/${this.editedItem.id}`)
        .then(response => {
          this.editedItem = { ...response.data };
          this.isItemRefreshing = false;
        })
        .catch(error => {
          console.error('Error fetching item data:', error);
          this.isItemRefreshing = false;
        });        
      },
      setSearchDataAfterGenerating(quotation) {
        this.searchedSuppliers.searchData = {
          merged_big_search: false,
          type_of_transport_company: ['Агент', 'Собственник', 'Перевозчик', 'Экспедитор'],
          set_services_ids: quotation.transport_types_id ? [quotation.transport_types_id]:[],
          need_employees_with_segments: true,
          set_special_features_ids: (quotation.adr == 'ADR') ? [969]:[],
          set_countries_of_branches_ids: [],
          set_countries_of_rolling_stock_ids: [],
          set_uploading_geography_ids: [],
          set_unloading_geography_ids: [],
          set_transit_directions_ids: quotation.set_transit_directions_ids,
          set_rf_directions_ids: [],
          set_transport_categories: [],
          set_insurance_data: []
        };

        let loadingPlaces = [];
        let unloadingPlaces = [];
        if (quotation.loading_places && quotation.loading_places.length) {
          loadingPlaces = quotation.loading_places.map((item) => {
            return item.country_id;
          });
        }

        if (quotation.unloading_places && quotation.unloading_places.length) {
          unloadingPlaces = quotation.unloading_places.map((item) => {
            return item.country_id;
          });
        }

        let transportTypesAndKinds = [];
        if (quotation.transport_types_and_kinds && quotation.transport_types_and_kinds.length) {
          transportTypesAndKinds = quotation.transport_types_and_kinds.map((item) => {
            return item.transport_item_id;
          });
        }

        this.searchedSuppliers.searchData.set_uploading_geography_ids = loadingPlaces;
        this.searchedSuppliers.searchData.set_unloading_geography_ids = unloadingPlaces;
        this.searchedSuppliers.searchData.set_transport_categories = transportTypesAndKinds;
      },
      generateFromDeliveryQuotation(lang = 'rus') {
        this.generatingFromDQ = true;

        const params = {
          order_id: this.orderId,
        };

        api.call('post', API_POST_ORDER_SERVICES_QUOTATIONS_FIND, params).then(({data}) => {
            if (lang === 'eng') {
                const todayEnglishDate = new Date().toLocaleDateString('en-US', {
                    day: '2-digit',
                    month: 'long',
                    year: 'numeric'
                });                

                this.editedItem.subject = 'Quotation Request for Transportation from TANAIS Broker JSC (dated ' + todayEnglishDate + ' / Order #' + this.orderId + ')';
            } else {
                this.editedItem.subject = 'Запрос котировки на перевозку от компании АО "ТАНАИС Брокер" (от ' + this.todayRussianDate() + ' / #' + this.orderId + ')';
            }

          if (data.success === true) {
            let generatedHTML = null;

            if (lang === 'eng') {
                generatedHTML = renderComponentToString(DeliveryQuotationLetterEng, {
                    quotation: data.quotation.data,
                });
            } else {
                generatedHTML = renderComponentToString(DeliveryQuotationLetter, {
                    quotation: data.quotation.data,
                });
            }

            this.editedItem.body = generatedHTML
                                    .replace(/(<p><br><\/p>){2,}/g, '') // Remove multiple consecutive <p><br></p>
                                    .replace(/<!---->/g, ''); // Remove all empty comments

            this.setSearchDataAfterGenerating(data.quotation.data);

            this.$bvToast.toast('Письмо успешно составлено! Ваша подпись будет автоматически добавлена в конце письма.', {
              title: 'Письмо успешно составлено',
              variant: 'success',
              solid: true,
            });
          } else {
            this.$bvToast.toast('Не найдено данных в форме на котировку в Логистике. Проверьте форму, перейдя в раздел Логистика.', {
              title: 'Письмо не может быть составлено',
              variant: 'warning',
              solid: true,
            });
          }
        }).catch((error) => {
          console.error('Ошибка при загрузке данных:', error);
          this.$bvToast.toast('Произошла ошибка при загрузке данных. Попробуйте еще раз.', {
            title: 'Ошибка',
            variant: 'danger',
            solid: true,
          });
        }).finally(() => {
          this.generatingFromDQ = false;
        });
      },
      todayRussianDate() {
        const today = new Date();
        
        const day = String(today.getDate()).padStart(2, '0');
        const month = String(today.getMonth() + 1).padStart(2, '0');
        const year = today.getFullYear();

        return `${day}.${month}.${year}`;
      }      
    }
  };
</script>
<style scoped>
  .fly-count {
    position: absolute;
    right: 15px;
    top: 0px;
  }
  .abs-sidebar-block {
    top: 0;
    left: 0;
    width: 100%;
    min-height: 100vh;
    background: #FFF;
    z-index: 9;
    padding-bottom: 15px;
  }
</style>